import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AuditList = Loadable(lazy(() => import("./AuditsList")));
const AuditAdd = Loadable(lazy(() => import("./AuditsAdd")));

const AuditRoutes = [
  { path: "/inv/assets/audit", element: <AuditList /> },
  { path: "/inv/assets/audit/:mode/:id", element: <AuditAdd /> },
];

export default AuditRoutes;
